import React from 'react';
import { Link } from 'react-router-dom';
// Constants
import { CompanyName } from '../../utils/Constants';
import { CONTACT_PAGE_URL } from '../../utils/Routes';
// Data
import {
  bookingPageAdditionalMeta,
  bookingPageStructuredData,
} from '../../utils/data/MetaData';
// Icons
import { MdDoubleArrow } from 'react-icons/md';
// Components
import BookingPageMainContainer from '../../components/booking/BookingPageMainContainer';
import { HelmetItem } from '../../components/utils/HelmetItem';
import Navbar from '../../components/nav/Navbar';
import FooterComponent from '../../components/footer/FooterComponent';

function BookingPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Booking'
        desc={`${CompanyName} — book commercials, UGC creation, or wellness coaching. Secure your spot today and get the help you need, tailored to your goals.`}
        keywords={`booking, schedule, commercials, UGC creator, wellness coaching, ${CompanyName}, Drammen Norway, worldwide`}
        additionalMeta={bookingPageAdditionalMeta}
        structuredData={bookingPageStructuredData}
      />

      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header
            className='grid w-full pt-[102px] lg:pt-[84px]'
            aria-labelledby='booking-page-title'
          >
            <div className='grid w-full px-8 text-center lg:container lg:mx-auto py-6 gap-4'>
              <div className='grid gap-y-4'>
                <h1
                  id='booking-page-title'
                  className='font-titleFont text-4xl w-full text-colour5 tracking-wide'
                >
                  Book Now
                </h1>
                <p className='text-base'>
                  Whatever you need my help with — commercials, UGC, or wellness
                  support. <br /> Tell me your goals and I’ll tailor it to you.
                </p>
              </div>

              <div className='grid justify-center'>
                <Link
                  to={CONTACT_PAGE_URL}
                  aria-label={`Learn more`}
                  className='grid text-xl md:text-sm w-full p-1 bg-colour5 text-colour1 shadow-lg font-semibold font-poppins hover:brightness-90 duration-200 h-fit'
                >
                  <div className='grid grid-cols-rev items-center border-[1px] border-colour1 border-solid gap-x-8 py-1 px-4'>
                    <span>OR CONTACT ME</span>
                    <MdDoubleArrow className='text-xl' />
                  </div>
                </Link>
              </div>
            </div>
          </header>
        </div>

        {/* Main */}
        <BookingPageMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
}

export default BookingPage;
